import { FC } from "react";
import RestrictedPage from "@/consumer/restrictedPage";
import AppointmentArchiveTable from "@/components/appointmentArchive/appointmentArchiveTable";
import ManagerAppointmentArchiveTable from "@/components/appointmentArchive/managerAppointmentArchiveTable";

interface Props {
  subdomain: string;
}

const AppointmentArchive: FC<Props> = ({ subdomain }) => {
  return (
    <RestrictedPage permissionRequired="frontend_view_appointment_archive">
      {subdomain === "manage" ? (
        <ManagerAppointmentArchiveTable />
      ) : (
        <AppointmentArchiveTable />
      )}
    </RestrictedPage>
  );
};

export default AppointmentArchive;
